import realEstateImage from '../Home/img/real-estate.png';
import transportImage from '../Home/img/transport.jpg';
import electronicsImage from '../Home/img/electronics.png';
import jobImage from '../Home/img/job.png';
import servicesImage from '../Home/img/services.png';
import homeImage from '../Home/img/home.png';
import gardenImage from '../Home/img/garden.png';
import childrenImage from '../Home/img/children.png';
import petsImage from '../Home/img/pets.png';
import fashionImage from '../Home/img/fashion.png';
import sportsImage from '../Home/img/sports.png';
import healthImage from '../Home/img/health.png';
import educationImage from '../Home/img/education.png';
import rentalImage from '../Home/img/rental.png';
import hobbiesImage from '../Home/img/hobbies.png';
import partsImage from '../Home/img/parts.png';
import accessoriesImage from '../Home/img/accessories.png';
import foodImage from '../Home/img/food.png';

export const categoryVisualMap = {
  "Житло та нерухомість": realEstateImage,
  "Транспорт": transportImage,
  "Гаджети": electronicsImage,
  "Карʼєра": jobImage,
  "Майстри та послуги": servicesImage,
  "Дім та затишок": homeImage,
  "Для саду та подвір'я": gardenImage,
  "Малеча": childrenImage,
  "Домашні улюбленці": petsImage,
  "Стиль": fashionImage,
  "Активність та спорт": sportsImage,
  "Б’юті": healthImage,
  "Знання та Навчання": educationImage,
  "Оренда та прокат": rentalImage,
  "Запчастини та аксесуари": partsImage,
  "Аксесуари": accessoriesImage,
  "Продукти та їжа": foodImage,
  "Хобі": hobbiesImage,
};
